import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const REGULAR_API_URL = `${API_HOST}/api`;

function* getRegularDocument() {
  yield takeEvery(actions.GET_REGULAR_DOCUMENT, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${REGULAR_API_URL}/regularCustomer/document`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.GET_REGULAR_DOCUMENT_END });
    }
  });
}

function* getRegularDocumentBoard() {
  yield takeEvery(actions.GET_BOARD_DOCUMENT, function* (action) {
    const { onSuccess, mappingCode } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${REGULAR_API_URL}/regularCustomer/document/${mappingCode}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.GET_BOARD_DOCUMENT_END });
    }
  });
}

function* updateRegularDocumentBoard() {
  yield takeEvery(actions.UPDATE_BOARD_DOCUMENT, function* (action) {
    const { onSuccess, mappingCode, mappedBoards } = action;
    const data = mappedBoards;
    try {
      const res = yield call(
        [axios, 'post'],
        `${REGULAR_API_URL}/regularCustomer/document/${mappingCode}`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_BOARD_DOCUMENT_END });
    }
  });
}

function* getRegularOrder() {
  yield takeEvery(actions.GET_ORDER, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${REGULAR_API_URL}/regularCustomer/order?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.GET_ORDER_END });
    }
  });
}

function* getRegularOrderDetail() {
  yield takeEvery(actions.GET_ORDER_DETAIL, function* (action) {
    const { order_id, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${REGULAR_API_URL}/regularCustomer/order/${order_id}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.GET_ORDER_DETAIL_END });
    }
  });
}

function* postRefundBank() {
  yield takeEvery(actions.POST_REFUND_BANK, function* (action) {
    const { onSuccess, data } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${REGULAR_API_URL}/regularCustomer/order/refund`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.POST_REFUND_BANK_END });
    }
  });
}

function* postRefundStaff() {
  yield takeEvery(actions.POST_REFUND_STAFF, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${REGULAR_API_URL}/regularCustomer/order/refundManually`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.POST_REFUND_STAFF_END });
    }
  });
}

function* putRefundRetry() {
  yield takeEvery(actions.PUT_REFUND_RETRY, function* (action) {
    const { onSuccess, data } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${REGULAR_API_URL}/regularCustomer/order/refund`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.PUT_REFUND_RETRY_END });
    }
  });
}

function* updatePayment() {
  yield takeEvery(actions.UPDATE_PAYMENT_DETAIL, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${REGULAR_API_URL}/payment/updatePaymentDetailWithThirdParty`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_PAYMENT_DETAIL_END });
    }
  });
}

function* getReceiptSetting() {
  yield takeEvery(actions.GET_RECEIPT_SETTING, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${REGULAR_API_URL}/regularCustomer/configuration/receipt`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.GET_RECEIPT_SETTING_END });
    }
  });
}

function* updateReceiptSetting() {
  yield takeEvery(actions.UPDATE_RECEIPT_SETTING, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${REGULAR_API_URL}/regularCustomer/configuration/receipt`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_RECEIPT_SETTING_END });
    }
  });
}

function* searchReceipt() {
  yield takeEvery(actions.PUT_RECEIPT_QUERY, function* (action) {
    const { id, onSuccess } = action;
    const data = { id };
    try {
      const res = yield call([axios, 'put'], `${REGULAR_API_URL}/receipt/query`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.PUT_RECEIPT_QUERY_END });
    }
  });
}

function* invoiceReceipt() {
  yield takeEvery(actions.PUT_RECEIPT_ISSUE, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${REGULAR_API_URL}/receipt/issue`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.PUT_RECEIPT_ISSUE_END });
    }
  });
}

function* invalidateReceipt() {
  yield takeEvery(actions.PUT_RECEIPT_INVALIDATE, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${REGULAR_API_URL}/receipt/invalidate`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.PUT_RECEIPT_INVALIDATE_END });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getRegularDocument),
    fork(getRegularDocumentBoard),
    fork(updateRegularDocumentBoard),
    fork(getRegularOrder),
    fork(getRegularOrderDetail),
    fork(postRefundBank),
    fork(postRefundStaff),
    fork(putRefundRetry),
    fork(updatePayment),
    fork(getReceiptSetting),
    fork(updateReceiptSetting),
    fork(searchReceipt),
    fork(invoiceReceipt),
    fork(invalidateReceipt),
  ]);
}
